import { FC } from "react";
import { Flex } from "@smile2impress/components/relaunch";

import {
    SocialIconNameType,
    SocialMediaIcon,
} from "components/Icons/SocialMediaIcon";
import Link from "components/Link";

export type SocialNetworkType = {
    iconName: SocialIconNameType;
    link: string;
};

type SocialNetworkProps = {
    socialNetworks: SocialNetworkType[];
};

export const FooterSocial: FC<SocialNetworkProps> = ({ socialNetworks }) => (
    <Flex>
        {socialNetworks.map(({ iconName, link }) => (
            <Link
                key={iconName}
                href={link}
                rel="noopener nofollow"
                w={2}
                h={2}
                mr={2}
                stroke="text.primary"
            >
                <SocialMediaIcon
                    iconName={iconName}
                    width="20px"
                    height="20px"
                    color="base.blue"
                    _dark={{
                        color: "text.base",
                    }}
                />
            </Link>
        ))}
    </Flex>
);
